import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'

const state = {
    roles: [],
    role: {
        role: '',
        privilegies: {},
    },

}

const getters = {
    roles: (state) => state.roles,
    role: (state) => state.role,
}

const actions = {
    loadRoles(context, credentials) {
        return appService
            .connectToServer(credentials)
            .then((data) => {
                context.commit('loadRoles', data.result)
            })
            .catch((error) => {
                context.dispatch('addMessage', { error: error.toString() }, { root: true })
            })
    },

    loadRole(context, credentials) {
        return appService
            .connectToServer(credentials)
            .then((data) => {
                context.commit('loadRole', data.result)
            })
            .catch((error) => {
                context.dispatch('addMessage', { error: error.toString() }, { root: true })
            })
    },

    async saveRole({ commit, dispatch }, credentials) {
        try {
            const data = await appService.connectToServer(credentials);
            if (data.success) {
                commit('saveRole', {
                    Role: data.Role,
                });
                dispatch('addMessage', data, { root: true });
                return data.Role;
            }
            dispatch('addMessage', data, { root: true });
        } catch (err) {
            dispatch('addMessage', err.toString(), { root: true });
        }
    },

    deleteRole(context, credentials) {
        return appService
            .connectToServer(credentials)
            .then((data) => {
                if (data.success) {
                    context.commit('deleteRole', { success: data.success, id: data.id })
                }
                context.dispatch('addMessage', data, { root: true })
            })
            .catch((error) => {
                context.dispatch('addMessage', { error: error.toString() }, { root: true })
            })
    },

    resetRole(context) {
        context.commit('resetRole')
    },
}

const mutations = {

    saveRole(state, { Role }) {
        state.role.requestLogCreate = Role.requestLogCreate;
        state.role.requestLogUpade = Role.requestLogUpade;
    },
    loadRoles(state, data) {
        state.roles = data
    },

    loadRole(state, data) {
        state.role = {
            id: data.id || '',
            role: data.role || '',
            privilegies:
                typeof data.privilegies === 'object' && data.privilegies !== null
                    ? _.cloneDeep(data.privilegies)
                    : {},
            requestLogCreate : data.requestLogCreate,
            requestLogUpade : data.requestLogUpade,
        }
    },

    deleteRole(state, data) {
        const index = _.findIndex(state.roles, (o) => o.id == data.id)
        if (index !== -1) {
            state.roles.splice(index, 1)
        }
    },

    resetRole(state) {
        state.role = {
            role: '',
            privilegies: {},
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
